import Vue from 'vue';
import querystring from 'querystring';
import * as RespuestasPredefinidas from '@lib/Preguntas/RespuestaPredefinida';
import { RespuestaPredefinida } from '@lib/Preguntas/RespuestaPredefinida';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait } from '@/__env/ext';
import { CuentasMercadoLibre } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';


export class ControladorDeRespuestasPredefinidas extends Vue
{

    public Buscador: Buscador = new Buscador();
    public Seleccionados: RespuestaPredefinida[] = [];
    limpiarSeleccionados()
    {
        this.editarSeleccionados( [] );
        this.$emit( 'limpiar-seleccionados' );
    }
    editarSeleccionados( Pedidos: RespuestaPredefinida[] )
    {
        this.Seleccionados = Pedidos;
        this.$emit( 'seleccionados' );

    }

    async crear( item: RespuestaPredefinida ): Promise<boolean>
    {
        if ( await item.save() )
        {
            this.Buscador.Items.push( item );
            this.Buscador.$emit( 'changed' );
            return true;
        }
        return false;
    }


    async editar( item: RespuestaPredefinida ): Promise<boolean>
    {
        let idx = this.Buscador.Items.findIndex( x => x.Id == item.Id );
        if ( await item.save() )
        {
            console.log(idx );
            if ( idx != -1 )
            {
                this.Buscador.Items.splice( idx, 1 );
                this.Buscador.Items.push( item);
                this.Buscador.$emit( 'changed' );
            }
            return true;
        }
        return false;
    }

    async eliminar( item: RespuestaPredefinida ): Promise<boolean>
    {
        let idx = this.Buscador.Items.findIndex( x => x.Id == item.Id );
        if ( await item.del() )
        {
            if ( idx != -1 )
            {
                this.Buscador.Items.splice( idx, 1 );
                this.Buscador.$emit( 'changed' );
            }
            return true;
        }
        return false;
    }
}

export class Buscador extends Vue
{
    public Items: RespuestaPredefinida[] = [];
    public Filtros: Filtros = new Filtros( this );
    public Estado: 'cargando' | 'vacio' | 'ok' | 'error' = 'cargando';
    public Paginacion: Paginacion;

    public async Buscar( pagina: number = null )
    {
        if ( pagina )
            this.Filtros.Valores.Pagina = pagina;

        this.Items.clear();
        this.Estado = 'cargando';

        this.$emit( 'changed' );


        await Wait( 100 );
        let e = await RespuestaPredefinida.find( this.Filtros.Obtener() );
        if ( e.Error )
            this.Estado = 'error';
        else
        {
            this.Items = e.Items;
            this.Paginacion = e.Paginacion;
            if ( this.Items.hasRows() )
                this.Estado = 'ok';
            else
                this.Estado = 'vacio';
        }

        this.$emit( 'changed' );
    }
}

export class Filtros
{
    constructor( b: Buscador )
    {
        this.Buscador = b;
    }

    public Buscador: Buscador;
    public Busqueda: string = '';

    public Valores: Record<string, number> = {
        Limite: 1,
        Orden: 0,
        Indice: 0,
        Cuenta: 0,
        Pagina: 1,
    };

    public get Cuentas() { return [...CuentasMercadoLibre]; }
    public get Limites() { return [{ Nombre: '5', Id: 5 }, { Nombre: '10', Id: 10 }, { Nombre: '20', Id: 20 }, { Nombre: '50', Id: 50 }]; }
    public get Ordenes() { return [{ Nombre: 'Descendente', Id: 'DESC' }, { Nombre: 'Ascendente', Id: 'ASC' }]; }
    public get Indices()
    {
        return [
            { Nombre: 'Id', Id: 'id' },
        ];
    }


    public get Activos(): { Nombre: string, Eliminar: any; }[]
    {

        let a: { Nombre: string, Eliminar: any; }[] = [];

        if ( this.Busqueda )
        {
            a.push( { Nombre: `Resultados para: ${this.Busqueda}`, Eliminar: () => { this.Busqueda = ''; this.Buscador.Buscar(); } } );
        }
        else
        {

            if ( this.Valores.Cuenta > 0 )
            {
                a.push( { Nombre: this.Cuentas[this.Valores.Cuenta].Nombre, Eliminar: () => { this.Valores.Cuenta = 0; this.Buscador.Buscar(); } } );
            }


        }

        return a;
    }

    public Obtener(): any
    {
        let filtro: any = {};




        if ( this.Valores.Cuenta > 0 )
        {
            filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
        }

        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }
        else
        {




        }

        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 )
        {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 )
        {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }

        return filtro;
    }

    public set( filtro: any )
    {

        if ( filtro.q )
        {
            this.Busqueda = String( filtro.q );
        }



        if ( filtro.cuenta )
        {
            this.Valores.Cuenta = 0;
            let idx = this.Cuentas.findIndex( x => x.Id == filtro.cuenta );
            if ( idx > 0 ) this.Valores.Cuenta = idx;
        }


        if ( filtro.limit )
        {
            this.Valores.Limite = 1;
            let idx = this.Limites.findIndex( x => x.Id == filtro.limit );
            if ( idx > 0 ) this.Valores.Limite = idx;
        }

        if ( filtro.sort )
        {
            this.Valores.Orden = 0;
            let idx = this.Ordenes.findIndex( x => x.Id == filtro.sort );
            if ( idx > 0 ) this.Valores.Orden = idx;
        }

        if ( filtro.order )
        {
            this.Valores.Indice = 0;
            let idx = this.Indices.findIndex( x => x.Id == filtro.order );
            if ( idx > 0 ) this.Valores.Indice = idx;
        }

        if ( filtro.page > 0 )
        {
            this.Valores.Pagina = filtro.page;
        }

    }

    public get(): string
    {
        let filtro: any = {};
        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }



        if ( this.Valores.Cuenta )
        {
            filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
        }


        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 )
        {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 )
        {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }


        return querystring.encode( filtro );
    }
}

const Controlador = new ControladorDeRespuestasPredefinidas();
export { Controlador };

